import { render, staticRenderFns } from "./PreviewPrivacy.vue?vue&type=template&id=7b0784b0"
import script from "./PreviewPrivacy.vue?vue&type=script&lang=js"
export * from "./PreviewPrivacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports